module.exports = __webpack_public_path__ + "static/media/comment.0bf20176.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/comment.svg
// module id = 1044
// module chunks = 36